import { useState } from "react";

// 定义本地存储的 key（统一管理，避免冲突）
const STORAGE_KEY = "UMI_ROUTE_DATA";

interface GlobalData {
  pname: string;
  ppath: string;
  pkey: string;
  reportCurrentConfig: any;
  todayReportStatus: number;
}

const getDefaultGlobalData = (): GlobalData => ({
  pname: "", // 路由名称
  ppath: "", // 跳转地址
  pkey: "", // 匹配的 key
  reportCurrentConfig: null,
  todayReportStatus: 0,
});

// 从本地存储读取初始数据（应用初始化时执行）
const getInitDataFromStorage = (): GlobalData => {
  try {
    const storageData = localStorage.getItem(STORAGE_KEY);
    if (storageData) {
      // 解析 JSON 数据，返回初始值
      return {
        ...getDefaultGlobalData(),
        ...JSON.parse(storageData),
      };
    }
  } catch (e) {
    console.error("从本地存储读取数据失败：", e);
  }
  // 本地存储无数据时，返回默认初始值
  return getDefaultGlobalData();
};

// 导出 Umi 全局 Model（useModel 可消费）
export default function useGlobalModel() {
  // 初始化状态：从本地存储读取数据
  const [globalData, setGlobalData] = useState<GlobalData>(getInitDataFromStorage());

  // 定义修改全局数据的方法（同步写入本地存储）
  const updateGlobalData = (newData: Partial<GlobalData>) => {
    const updatedData = { ...globalData, ...newData };
    // 1. 更新组件状态
    setGlobalData(updatedData);
    // 2. 同步写入本地存储（实现持久化）
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedData));
    } catch (e) {
      console.error("写入本地存储失败：", e);
    }
  };

  // 定义清除全局数据的方法（如退出登录）
  const clearGlobalData = () => {
    setGlobalData(getDefaultGlobalData());
    localStorage.removeItem(STORAGE_KEY);
  };

  // 暴露给组件消费的数据和方法
  return {
    globalData,
    updateGlobalData,
    clearGlobalData,
  };
}
